
import { Vue, Component } from "vue-property-decorator";
import editor from "./editor"; // твой миксин
import moment from "moment";

@Component({
  mixins: [editor],
})
export default class StringInlineEditor extends Vue {
  save: any;
  // Основное значение (хранится как строка в формате ISO: "2025-08-28T07:03:00")
  value: string | null = null;
  editMode: any;

  // Временное значение для редактирования (в формате DD.MM.YYYY HH:mm)
  tempDisplayValue: string = "";

  // === Вычисляемые свойства ===

  public get displayValue(): string {
    if (!this.value) return "";
    // Нестрогий парс: API отдаёт дату в разных ISO-вариантах (с долями секунд/
    // смещением). Строгий moment(..., "YYYY-MM-DDTHH:mm:ss", true) их отвергал →
    // displayValue="" → пустой <p> без кликабельной области (нельзя было открыть
    // редактор у уже заполненной даты). moment(value) принимает валидный ISO.
    const m = moment(this.value);
    if (!m.isValid()) return "";
    return m.format(this.dateFormat);
  }

  public get isValidValue(): boolean {
    if (!this.tempDisplayValue) return true;
    const m = moment(this.tempDisplayValue, this.dateFormat, true);
    return m.isValid();
  }

  public get placeholder(): string {
    return (this as any).field?.config?.dateFormat ?? "DD.MM.YYYY HH:mm";
  }

  public get dateFormat(): string {
    return "DD.MM.YYYY HH:mm";
  }

  public get maskValue(): string {
    return (this as any).field?.config?.mask ?? (this as any).field?.mask ?? "##.##.#### ##:##";
  }

  public get errorMessages(): string[] {
    if (!this.editMode) return [];
    if (!this.tempDisplayValue) return [];
    return this.isValidValue ? [] : ["Неверный формат даты"];
  }

  public get hideDetails(): boolean {
    return !!this.errorMessages.length;
  }

  public get notDefinedCaption(): string {
    return (this as any).field?.notDefinedCaption ?? "не задано";
  }

  public get readonly(): boolean {
    return (this as any).field?.readonly ?? false;
  }

  // === Методы ===

  setEditMode(): void {
    if (this.readonly) return;
    (this as any).editMode = true;
    this.tempDisplayValue = this.displayValue;
    this.$nextTick(() => {
      const input = this.$el.querySelector("input");
      if (input) input.focus();
    });
  }

  onInput(value: string): void {
    this.tempDisplayValue = value;
  }

  async saveDate(): Promise<void> {
    console.log("Сохраняем дату:", this.tempDisplayValue);

    // Если пусто — сохраняем null
    if (!this.tempDisplayValue || this.tempDisplayValue.trim() === "") {
      this.value = null;
      await this.save();
      return;
    }

    // Парсим ввод
    const m = moment(this.tempDisplayValue, this.dateFormat, true);
    if (m.isValid()) {
      // Формируем строку без UTC-сдвига: "2025-08-28T07:03:00"
      this.value = m.format("YYYY-MM-DDTHH:mm:ss");
      await this.save();
    } else {
      console.warn("Неверный формат даты, отмена изменений");
      this.cancelChanges();
    }
  }

  cancelChanges(): void {
    (this as any).editMode = false;
    this.tempDisplayValue = "";
  }
}
